<script>
import App from "@/pages/layouts/app.vue";
import Card from "@/pages/components/card.vue";
import Datatable from "@wielink-application/shared/js/mixins/datatable";
import {Link} from "@inertiajs/vue3";

export default {
  components: {App, Card, Link},
  mixins: [Datatable],
  methods: {
    async syncPrices() {
      let confirmed = await Helpers.Alert.confirm('Weet je het zeker?');

      if(!confirmed) {
        return;
      }

      $.ajax({
        url: route('api.v1.parts.sync_prices'),
        method: 'post',
        success: (response) => {
          Helpers.Message.success('De prijzen worden in de achtergrond opgehaald, dit kan tot een minuut duren.')
        },
        error: (error) => {
          Helpers.Message.error(error.responseJSON.message)
        }
      });
    }
  }
}
</script>
<template>
  <App title="Onderdelen">
    <template #topButtons>
      <div class="d-flex gap-2">
        <button @click.prevent="syncPrices" class="btn btn-secondary">
          <i class="bi bi-currency-euro"></i>
          Prijzen ophalen
        </button>

        <Link :href="route('parts.create')" class="btn btn-primary">
          <i class="bi bi-plus-lg"></i>
          Onderdeel toevoegen
        </Link>
      </div>
    </template>

    <Card>
      <Table ref="table" id="parts" :config="tableConfig"/>
    </Card>
  </App>
</template>